import { render, staticRenderFns } from "./NotiItem.vue?vue&type=template&id=f82be6c8&scoped=true&"
import script from "./NotiItem.vue?vue&type=script&lang=js&"
export * from "./NotiItem.vue?vue&type=script&lang=js&"
import style0 from "./NotiItem.vue?vue&type=style&index=0&id=f82be6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82be6c8",
  null
  
)

export default component.exports